import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/drivers/")({
  component: lazyRouteComponent(() => import("./-pages/admin.drivers")),
});
